// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3gyE0","subheader":"ReorderModal_subheader__3AnWB","listWrap":"ReorderModal_listWrap__2NEl1"};